// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6c97079b1b--wrapper--umepf"};